import { selectRouterPathname } from '@noths/polaris-client-next-redux';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { replace } from 'connected-next-router';

import { adaptStoreToPageURL } from 'src/adapters/storeToPageQueryString/adaptStoreToPageURL';
import { buildListingsURL } from 'src/adapters/storeToPageQueryString/buildListingsURL';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const updatePageURLWithQuery = createAsyncThunk(
  'products/updatePageURLWithQuery',
  async (_, { dispatch, getState }) => {
    const state = getState() as ReduxApplicationState;
    const { pathname } = state.router.location;
    const routerPathname = selectRouterPathname(state);
    const { page } = state.productsQuery;
    const urlParams = adaptStoreToPageURL(state, page);
    const href = buildListingsURL(routerPathname, urlParams, state.navigation.hash);
    const as = buildListingsURL(pathname, urlParams, state.navigation.hash);

    dispatch(replace(href, as, { shallow: true, scroll: false }));
  },
);
